import { useCallback } from 'react';

import {
	useAgentFavourites,
	useAgentUrlActions,
	useDeleteAgent,
} from '@atlassian/conversation-assistant-agent';
type UseAgentActionsProps = {
	product: string;
	cloudId: string;
	agentId?: string;
};

export const useAgentActions = ({ product, cloudId, agentId }: UseAgentActionsProps) => {
	const { favouriteAgent, unfavouriteAgent } = useAgentFavourites({
		experienceId: 'profile-page',
		product,
	});

	const { onEditAgent, onCopyAgent, onDuplicateAgent } = useAgentUrlActions({ siteId: cloudId });
	const { deleteAgent: deleteRovoAgent } = useDeleteAgent({
		experienceId: 'profile-page',
		product,
	});

	const setFavouriteAgent = useCallback(
		async (isFavourite: boolean) => {
			if (!agentId) {
				return;
			}
			if (isFavourite) {
				return await favouriteAgent.mutate(agentId);
			} else {
				return await unfavouriteAgent.mutate(agentId);
			}
		},
		[agentId, favouriteAgent, unfavouriteAgent],
	);

	const editAgent = () => {
		if (!agentId) {
			return;
		}
		onEditAgent(agentId);
	};
	const copyAgent = () => {
		if (!agentId) {
			return;
		}
		onCopyAgent(agentId);
	};
	const duplicateAgent = () => {
		if (!agentId) {
			return;
		}
		onDuplicateAgent(agentId);
	};

	const deleteAgent = () => {
		if (!agentId) {
			return;
		}
		deleteRovoAgent.mutate(agentId);
	};

	return {
		setFavouriteAgent,
		editAgent,
		copyAgent,
		duplicateAgent,
		deleteAgent,
	};
};
